export enum BannerLocationType {
  HomePage = 'HOME_PAGE',
  SubscribePage = 'SUBSCRIBE_PAGE',
  HomePageHeader = 'HOME_PAGE_HEADER',
  SubscribePageHeader = 'SUBSCRIBE_PAGE_HEADER',
}
